import React, { FC } from 'react';
import s from './spinner.module.scss';

const Spinner: FC = () => {
  return <div className={s.spinner}></div>;
};

export default Spinner;
